import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';
import {
  buildProjectCostRatesMutationOptions,
  mapProjectRatesToCostRateInput,
  mapRemovedCostRateGroupsInput
} from './usePutProjectCostRates';

export const UPDATE_PROJECT_COST_RATES = gql`
  mutation updateProjectCostRates(
    $projectId: String!
    $dimensionUris: [String!]
    $requiredDimensionUris: [String!]
    $rates: [ProjectRateInput3!]
  ) {
    updateProjectCostRates(
      projectId: $projectId
      dimensionUris: $dimensionUris
      requiredDimensionUris: $requiredDimensionUris
      rates: $rates
    ) {
      id
      dimensions {
        dimensionUri
        objectUri
      }
      scheduleEntries {
        amount {
          amount
          currency {
            id
          }
        }
      }
    }
  }
`;

export const useUpdateProjectCostRates = () => {
  const [updateProjectCostRatesMutation, { loading }] = useMutation(
    UPDATE_PROJECT_COST_RATES
  );

  return {
    updateProjectCostRates: async ({
      projectId,
      selectedDimensions,
      projectRates,
      persistedRates
    }) => {
      const rates = mapProjectRatesToCostRateInput(
        selectedDimensions,
        projectRates
      ).concat(
        mapRemovedCostRateGroupsInput(
          selectedDimensions,
          persistedRates,
          projectRates
        )
      );
      const dimensionUris = selectedDimensions.map(d => d.id);

      // No updatedDimensions: an update never changes the dimension set, so the
      // dimensions cache is already correct and must not be rewritten mid-save.
      return updateProjectCostRatesMutation(
        buildProjectCostRatesMutationOptions({
          projectId,
          dimensionUris,
          rates
        })
      );
    },
    isSaving: loading
  };
};
